import NamingSchemeModalForm from './NamingSchemeModalForm'

export default NamingSchemeModalForm
